import { authHeader, config, handleError, handleResponse } from "_helpers";

export const interviewService = {
  getInterviewFormList,
  saveInterviewForm,
  getInterviewForm,
  generateInterviewPdf,
  deleteInterviewForm,
};

function getInterviewFormList(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: data,
  };
  return fetch(config.apiUrl + `/api/interviewform/list`, requestOptions).then(
    handleResponse,
    handleError,
  );
}

function getInterviewForm(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    config.apiUrl + `/api/interviewform/content/${id}`,
    requestOptions,
  ).then(handleResponse, handleError);
}

function saveInterviewForm(data) {
  const requestOptions = {
    headers: authHeader(),
    method: "POST",
    body: JSON.stringify(data),
  };
  return fetch(config.apiUrl + "/api/interviewform/save", requestOptions).then(
    handleResponse,
    handleError,
  );
}

function deleteInterviewForm(data) {
  const requestOptions = {
    headers: authHeader(),
    method: "POST",
    body: data,
  };
  return fetch(
    config.apiUrl + "/api/interviewform/delete",
    requestOptions,
  ).then(handleResponse, handleError);
}

function generateInterviewPdf(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    config.apiUrl + `/api/interviewform/pdf/${id}`,
    requestOptions,
  ).then(handleResponse, handleError);
}
